import classNames from 'classnames';
import ToExternalPurchasePageButton from 'components/region/LiftTicketTable/components/ToExternalPurchasePageButton';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import isLiftsUrlWhiteListed from 'util/isLiftsUrlWhiteListed';
import styles from './styles.module.scss';

interface ISpecialNoteProps {
  note: string | null
  purchaseUrl?: string | null
  disclaimer: string
  isPartner: boolean
}
const SpecialNote = ({
  note, purchaseUrl, disclaimer, isPartner,
}: ISpecialNoteProps) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={styles.specialNoteBlock}>
      <div className={classNames(styles.purchaseBlock, { [styles.transparentBorder]: !note })}>
        <span className={classNames(styles.note, { [styles.transparent]: !note })}>
          <strong>
            {t('resort.liftTickets.specialNote')}
            {': '}
          </strong>
          <span>{note}</span>
        </span>
        <span className={styles.externalLink}>
          {(isPartner || isLiftsUrlWhiteListed(purchaseUrl)) && <ToExternalPurchasePageButton url={purchaseUrl || '/'} />}
        </span>
      </div>
      <p>{disclaimer}</p>
    </div>
  );
};

export default SpecialNote;
